import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/App.css';

// ============================================================
// FIX: Disable React DevTools in production
// ============================================================
 

// ============================================================
// Enable React DevTools in production (DEBUG ONLY)
// Remove this before final deployment!
// ============================================================
if (process.env.NODE_ENV === 'production') {
  // Enable DevTools in production
  if (window.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
    // This enables DevTools to work in production
    window.__REACT_DEVTOOLS_GLOBAL_HOOK__.inject = () => {};
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);